import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Reveal, WhatsAppIcon } from "./Extras";
import { FAQ_ITEMS, buildWhatsAppUrl, B2B_URL } from "../data/content";

const Faq = ({ config }) => (
    <section id="preguntas" data-testid="faq-section" className="bg-brand-cream py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="grid gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-16">
                <Reveal>
                    <p className="text-sm font-bold uppercase tracking-widest text-brand-magenta">Preguntas frecuentes</p>
                    <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-brand-ink sm:text-4xl">
                        Resolvemos tus dudas
                    </h2>
                    <p className="mt-4 text-base leading-relaxed text-brand-muted">
                        Todo sobre dónde comprar LoloPets, cómo alimentar a tu ave, conejo o roedor, y
                        cómo sumar la marca a tu negocio.
                    </p>
                    <a
                        data-testid="faq-cta-whatsapp"
                        href={buildWhatsAppUrl(config?.whatsapp)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-7 inline-flex min-h-[44px] items-center gap-2 rounded-full bg-brand-magenta px-8 py-3 font-display font-semibold text-white shadow-soft transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-magentadark hover:shadow-lift"
                    >
                        <WhatsAppIcon className="h-4 w-4" /> Preguntar por WhatsApp
                    </a>
                    <div>
                        <a
                            data-testid="faq-cta-b2b-form"
                            href={B2B_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-magenta underline-offset-4 transition-colors duration-200 hover:text-brand-magentadark hover:underline"
                        >
                            ¿Querés vender LoloPets? Formulario de nuevos clientes →
                        </a>
                    </div>
                </Reveal>
                <Reveal delay={0.1}>
                    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                        {FAQ_ITEMS.map((item, i) => (
                            <AccordionItem
                                key={i}
                                value={`faq-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="border-b border-brand-purple/10"
                            >
                                <AccordionTrigger
                                    data-testid={`faq-question-${i}`}
                                    className="min-h-[44px] py-5 text-left font-display text-base font-semibold text-brand-ink hover:text-brand-magenta hover:no-underline sm:text-lg"
                                >
                                    {item.q}
                                </AccordionTrigger>
                                <AccordionContent
                                    data-testid={`faq-answer-${i}`}
                                    className="pb-5 text-sm leading-relaxed text-brand-muted sm:text-base"
                                >
                                    {item.a}
                                    {item.link && (
                                        <a
                                            data-testid={`faq-link-${i}`}
                                            href={item.link.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="mt-3 inline-flex items-center gap-1.5 font-semibold text-brand-magenta underline-offset-4 transition-colors duration-200 hover:text-brand-magentadark hover:underline"
                                        >
                                            {item.link.label} →
                                        </a>
                                    )}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </div>
    </section>
);

export default Faq;
